import Vue from 'vue'
import Router from 'vue-router'
import Writing from '@/views/Writing'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			redirect: '/writing',
		},
		{
			path: '/writing',
			name: 'Writing',
			component: Writing
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js